import type {
  GetV2OsInstallersQueryParams,
  GetV2OsInstallersVersionDownloadQueryParams,
} from '@emma/api_client/types';
import { type ReadToastOptions, useApiFetch, useCallApi } from '../api';

export function useOsInstallers(
  params: GetV2OsInstallersQueryParams = {},
  toastOptions?: ReadToastOptions
) {
  return useApiFetch(
    `os-installers?${JSON.stringify(params)}`,
    async (callApi) => callApi((api) => api.os.getV2OsInstallers(params)),
    toastOptions
  );
}

export function useInstallerDownload() {
  const callApi = useCallApi();

  const download = async (
    version: string,
    architecture: GetV2OsInstallersVersionDownloadQueryParams['architecture'],
    variant: GetV2OsInstallersVersionDownloadQueryParams['variant']
  ) => {
    const result = await callApi((api) =>
      api.os.getV2OsInstallersVersionDownload({ version }, { architecture, variant })
    );
    window.open(result.data.downloadUrl, '_blank', 'noopener,noreferrer');
  };

  return download;
}
